import { identity, get } from 'lodash-es';
import { createSelector } from 'reselect';

const getRouteImoportDetailsFormInitialValues = (routeImportDetails: any) =>
  get(routeImportDetails, 'routeImportDetails', {});

const routeImportDetailsFormInitialValuesSelector = createSelector(getRouteImoportDetailsFormInitialValues, identity);

export default routeImportDetailsFormInitialValuesSelector;
